interface AppConfig {
    basePath: string
}

let _config: AppConfig | null = null

export async function loadAppConfig(): Promise<void> {
    const response = await fetch(`${process.env.PUBLIC_URL}/app.config.json`)
    _config = await response.json()
}

export function getAppConfig(): AppConfig {
    if (!_config) throw new Error('App config not loaded yet')
    return _config
}
